import styled from 'styled-components';

export const Overdue = styled.i`
  color: #e34850;
  font-size: 12px;
`;

export const Wrap = styled.div`
  position: absolute;
  width: 100%;
  height: 100vh;
`;

export const TaskCard = styled.div`
  background-color: #ffffff;
  overflow: hidden;
  display: ${props => props.display};
  margin: 20px ${props => `${props.right}%`} 20px ${props => `${props.left}%`};
  border-radius: 0 4px 4px 0;
  box-shadow: 0 0 1px #eaeaea inset;
  transition: all 950ms;
  padding: 15px;
  position: relative;

  &:hover {
    margin-left: ${props => (props.left < 20 ? props.left : 20)}%;
    margin-right: ${props => (props.right < 20 ? props.right : 20)}%;

    box-shadow: 0px 0px 21px -5px rgba(0, 0, 0, 0.61);
  }
`;

export const TaskColor = styled.div`
  background-color: ${props => props.color};
  padding: 0;
  border-radius: 0 4px 0 0;
  height: 6px;
  width: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
`;

export const CardContent = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const CardContentMiddle = styled.div`
  height: 100%;
  width: 85%;
`;

export const ProjectName = styled.div`
  color: #2c2c2c;
  font-size: 14px;
  margin-bottom: 9px;
  font-weight: bold;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const DueDate = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-width: 55px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;

  span {
    font-size: 12px;
    color: #8e8e8e;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-weight: 300;
  }
`;

export const Circle = styled.div`
  min-width: 9px;
  min-height: 9px;
  background: #${({ color }) => color};
  border-radius: 50%;
  margin-right: 7px;
`;

export const CardContentRight = styled.div`
  min-width: 50px;
  max-width: 75px;
  margin: left;
  position: relative;
`;

export const Actions = styled.div`
  height: 10px;
  width: 24px;
  display: flex;
  justify-content: right;
  position: absolute;
  right: -5px;

  .action-button {
    background-color: #ffffff;
    color: #8e8e8e;
    border: none;
    height: 10px;
  }
`;

export const Status = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 14px;
  height: 32px;
  font-size: 12px;

  i {
    color: #8e8e8e;
    font-weight: 300;
  }
`;

export const StatusText = styled.span`
  display: flex;
  align-items: center;
  color: #2c2c2c;
  font-size: 12px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
`;
